export default __webpack_public_path__ + "images/SZ.ea5428c.png";